/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LocalizationWithComponent } from '@/components/blocks/LocalizationWithComponent';
import { resultsHeader } from '@/components/content/CatalogEntryList/styles/resultsHeader';
import { useCatalogEntryList } from '@/data/Content/CatalogEntryList';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';

export const CatalogEntryListResultsHeader: React.FC<{ isCategoryPage?: boolean }> = ({
	isCategoryPage,
}) => {
	const {
		total,
		filteredParams: { searchTerm },
		searchSuggestion,
		categoryTitle
	} = useContext(ContentContext) as ReturnType<typeof useCatalogEntryList> & {
		searchSuggestion: string;
	};
	
	const productGridNLS = useLocalization('ProductGrid');
	const searchTitle = searchSuggestion ? searchSuggestion : searchTerm ?? '';

	return (
		<Box sx={resultsHeader.container}>
			<Typography
				component="h1"
				variant="headingTitle"
				sx={resultsHeader.searchTermTitle(!!isCategoryPage)}
			>
				{isCategoryPage ? (
					categoryTitle
				) : (
					<LocalizationWithComponent
						text={productGridNLS.Labels.searchTitleLabel.t({
							searchTerm: searchTitle,
						})}
						components={[<b key="b" />]}
					/>
				)}
			</Typography>
			<Typography component="span" variant="textSegment" color="grey.500">
				{productGridNLS.Labels.productFound.t({ count: total || 0 })}
			</Typography>
		</Box>
	);
};
